import { createContext, useContext } from "react";

export const SlideMenuCollapsedContext = createContext(false);

export const useIsSlideMenuCollapsed = () =>
  useContext(SlideMenuCollapsedContext);
